import { extendTheme } from '@chakra-ui/react';
import { theme } from '@codametrix/themes/chakra/biome';
import { theme as chakraV1Theme } from "@chakra-ui/theme";
export default extendTheme(theme, chakraV1Theme, {
  useSystemColorMode: false,

  fonts: {
    body: "'Roboto', Arial, Helvetica, sans-serif",
    heading: "'Roboto', Arial, Helvetica, sans-serif",
  },
  
  components: {
    Alert: {
      baseStyle: {
        container: {
          display: 'block !important',
          p: 0,
          m: 0,
          bg: 'transparent',
          border: 'none',
          borderRadius: 0,
          fontFamily: 'inherit',
          flexDirection: 'initial',
          alignItems: 'initial',
          justifyContent: 'initial',
          flexWrap: 'initial',
          gap: 0,
        },
        title: {
          display: 'block !important',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: '1.2',
          mb: 1,
          p: 0,
          color: 'inherit',
          width: '100%',
        },
        description: {
          display: 'block !important',
          fontSize: '12px',
          lineHeight: '1.2',
          p: 0,
          m: 0,
          color: 'inherit',
          opacity: 0.85,
          width: '100%',
        },
        icon: {
          display: 'none',
        },
      },
      variants: {
        transparent: {
          container: {
            bg: 'transparent',
            border: 'none',
            p: 0,
            m: 0,
          },
        },
      },
      defaultProps: {
        variant: 'transparent',
      },
    },
    
    CloseButton: {
      baseStyle: {
        _focus: {
          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
        },
      },
    },
  },
  
  styles: {
    global: {
      'html': {
        boxSizing: 'border-box',
        lineHeight: 1.5,
        WebkitTapHighlightColor: 'transparent',
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit',
      },
      'body': {
        margin: 0,
        fontSize: '14px',
        color: '#3b4351',
        textRendering: 'optimizeLegibility',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      'a': {
        color: '#5755d9',
        outline: 0,
        textDecoration: 'none',
      },
      'a:focus': {
        boxShadow: '0 0 0 .1rem rgba(87,85,217,.2)',
      },
      'a:hover, a:active, a:focus': {
        color: '#302ecd',
        textDecoration: 'underline',
      },
      'h1, h2, h3, h4, h5, h6': {
        color: 'inherit',
        fontWeight: 500,
        lineHeight: 1.2,
        marginBottom: '.5em',
        marginTop: 0,
      },

      '.chakra-alert': {
        display: 'block !important',
   
        flexDirection: 'initial !important',
        alignItems: 'initial !important',
        justifyContent: 'initial !important',
        flexWrap: 'initial !important',
        gap: '0 !important',
      },

      '.chakra-alert__title': {
        display: 'block !important',
        float: 'none !important',
        clear: 'both !important',
      },
      
      '.chakra-alert__desc': {
        display: 'block !important',
        float: 'none !important',
        clear: 'both !important',
      },
      
      '.highlight-drawer .chakra-alert': {
        marginBottom: '8px !important',
      },
      
      '.highlight-drawer .chakra-alert__title': {
        fontSize: '14px !important',
        fontWeight: 'normal !important',
        marginBottom: '4px !important',
        color: 'inherit !important',
      },
      
      '.highlight-drawer .chakra-alert__desc': {
        fontSize: '12px !important',
        opacity: '0.85 !important',
        color: 'inherit !important',
      },
    },
  },
});